<template>
    <div class="flex items-center whitespace-nowrap">
      <button
        class="text-base rounded-sm px-1.5 py-0.5 underline"
        :class="hasPrev ? 'hover:bg-gray-200 cursor-pointer' : 'opacity-30 cursor-not-allowed'"
        :disabled="!hasPrev"
        @click="goToFirst"
        >&lt;&lt;</button
      >
      <button
        class="text-base rounded-sm px-1.5 py-0.5 underline"
        :class="hasPrev ? 'hover:bg-gray-200 cursor-pointer' : 'opacity-30 cursor-not-allowed'"
        :disabled="!hasPrev"
        @click="getPrev"
        >&lt;</button
      >
      <div class="flex flex-row items-center px-1">
        Page
        <button
          ><JumpToPage class="mx-1" :current-page="page" :max-page="countIsCapped ? null : numPages" @fetch-page="jumpToPage"
        /></button>
            of {{ displayedNumPages }}
      </div>
      <button
        class="text-base rounded-sm px-1.5 py-0.5 underline"
        :class="hasNext ? 'hover:bg-gray-200 cursor-pointer' : 'opacity-30 cursor-not-allowed'"
        :disabled="!hasNext"
        @click="getNext"
        >></button
      >
      <button
        class="text-base rounded-sm px-1.5 py-0.5 underline"
        :class="canGoToLast ? 'hover:bg-gray-200 cursor-pointer' : 'opacity-30 cursor-not-allowed'"
        :disabled="!canGoToLast"
        :title="countIsCapped ? 'Total pages unknown — use > to keep paging' : null"
        @click="goToLast"
        >>></button
      >
    </div>
  </template>
  
  <script setup>
  import { defineProps, defineEmits, computed } from "vue";
  import JumpToPage from "./JumpToPage.vue";
  
  const props = defineProps(["page", "numPages", "hasNext", "hasPrev", "countIsCapped", "isPastEnd"]);
  const emit = defineEmits(['go-to-first', 'go-to-last', 'get-prev', 'get-next', 'jump-to-page'])

  // When the backend caps its count, numPages is only the lowest page total we
  // know of. Once we've paged past it the current page is a better floor, and
  // on a page with no next page it's the exact total — so "20+" ... "7".
  const displayedNumPages  = computed(() => {
    if (!props.countIsCapped) return props.numPages ? props.numPages.toLocaleString() : 0
    // An empty page past the end proves nothing about the total, so the floor
    // stays where the count left it — "Page 400 of 20+", not "of 400".
    const knownPages = props.isPastEnd
      ? (props.numPages || 0)
      : Math.max(props.numPages || 0, props.page || 0)
    return (props.hasNext || props.isPastEnd)
      ? `${knownPages.toLocaleString()}+`
      : knownPages.toLocaleString()
})

  // "Jump to last" needs a real last page; with a capped count there isn't one.
  const canGoToLast = computed(() => props.hasNext && !props.countIsCapped)
  
  
  function goToLast() {
      emit('go-to-last')
  }
  function goToFirst() {
      emit('go-to-first')
  }
  function getPrev() {
      emit('get-prev')
  }
  function getNext() {
      emit('get-next')
  }
  
  function jumpToPage(pageToJump) {
    emit('jump-to-page', pageToJump);
  }
  </script>